module.exports = __webpack_public_path__ + "static/15-2b740009a5202a1fee36ff88e774722b.jpg";